import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { AuthenticationService } from '../authentication.service';
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';

declare var jsSHA: any;

@Component({
  selector: 'app-change-email-password',
  templateUrl: './change-email-password.component.html',
  styleUrls: ['./change-email-password.component.scss'],
  providers: [ AuthenticationService ]
})
export class ChangeEmailPasswordComponent extends BaseComponent implements OnInit {

  shaObj: any;
  email: string = "";
  confirmEmail: string = "";
  password: string = "";
  confirmPassword: string = "";

  invalidEmail: boolean = false;
  invalidPassword: boolean = false;
  emailChangeSuccess: boolean = false;
  passwordChangeSuccess: boolean = false;
  serverError: boolean = false;
  serverMessage: string = "";

  @Output() onAuthFail = new EventEmitter();

  constructor(private authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
  }

  onEmailChange(email) {
    this.email = email;
  }

  onConfirmEmailChange(email) {
    this.confirmEmail = email;
  }

  onPasswordChange(password) {
    this.password = password;
  }

  onConfirmPasswordChange(password) {
    this.confirmPassword = password;
  }

  hashPassword(): string {
    this.shaObj = new jsSHA("SHA-256", "TEXT");
    this.shaObj.update(this.password);
    return this.shaObj.getHash("HEX");
  }

  changePassword() {

    if(!ValidationHelper.isValidString(this.password) || !ValidationHelper.isValidString(this.confirmPassword) ||
    this.password != this.confirmPassword) {
      this.invalidPassword = true;
      return;
    }

    this.invalidPassword = false;

    this.authenticationService.changePassword(Global.getCountry(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), this.hashPassword()).subscribe(res => {

      if(res && res["message"] == BaseService.COULDNT_LOAD_USER) {
        Global.clearSaveUserInfos();
        this.onAuthFail.emit();
      }
      else if(res && res["status"] == "success"){
        this.passwordChangeSuccess = true;
      }

    }, err => {
      Log.getInstance().d(err);
    });
  }

  changeEmail() {

    this.serverError = false;
    this.emailChangeSuccess = false;

    if(!ValidationHelper.isValidString(this.email) || !ValidationHelper.isValidString(this.confirmEmail) ||
    !ValidationHelper.isValidEmail(this.email) || this.email != this.confirmEmail){
      this.invalidEmail = true;
      return;
    }

    this.invalidEmail = false;

    this.authenticationService.changeMail(Global.getCountry(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), this.email).subscribe(res => {
      if(res && res["status"] == "success") {
        this.emailChangeSuccess = true;
      }
      else if(res && res["message"] == BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.onAuthFail.emit();
      }
      else {
        this.serverError = true;
        this.serverMessage = res["message"];
      }

    }, err => {
      Log.getInstance().d(err);
    });
  }

}
